import React from 'react';
import useTranslationLgs from '@hooks/i18n/useTranslation';
import { SupplierNotificationPreviewOutDTO, SupplierNotificationTypeEnum } from '@api/ringil-api.v2';
import useNavigation from '@hooks/useNavigation';
import LinkedEntitiesBadge from '@components/ringil3/Badges/LinkedEntitiesBadge';

interface ComponentProps {
  /** One notification or several; nothing is rendered for an empty or missing value. */
  supplierNotifications?: SupplierNotificationPreviewOutDTO | SupplierNotificationPreviewOutDTO[];
  /** Overrides the default "Avizace"; a list names what it is a list of, e.g. its count. */
  label?: string;
  dataTestId?: string;
}

/**
 * Supplier notifications linked to whatever is on screen — the shipment's own origin notification,
 * or the ones a merge folded into it.
 *
 * The SN-flavoured wrapper around {@link LinkedEntitiesBadge}: it is what knows the label and how an
 * SN detail is addressed, so no caller has to build that URL for itself.
 */
const LinkedSNBadge: React.FC<ComponentProps> = ({ supplierNotifications, label, dataTestId }) => {
  const { tr } = useTranslationLgs();
  const nav = useNavigation();

  const notifications = ([] as SupplierNotificationPreviewOutDTO[]).concat(supplierNotifications ?? []);

  return (
    <LinkedEntitiesBadge
      label={label ?? tr(`LinkedCNBadge.avizace`, `Avizace`)}
      links={notifications.map(notification => ({
        id: notification.supplierNotificationId,
        applicationId: notification.supplierNotificationApplicationId,
        note: notification.supplierName,
        to: nav.createNavigationLink(nav.urlFunctions.createSupplierNotificationDetail(notification.supplierNotificationId, SupplierNotificationTypeEnum.EFXX)),
      }))}
      dataTestId={dataTestId ?? 'expeditionSummary-linkedSN'}
    />
  );
};

export default LinkedSNBadge;
